<template>
     <a-spin :spinning="spinning" class="spinning_box">
        <div class="TeachersTeachingProgressStatistics">
            <div class="TeachersTeachingProgressStatistics_Title">
                <TitlesImg :type="record.titleImgType" />
                <span class="TeachersTeachingProgressStatistics_Span">{{ record.title }} </span>
            </div>
            <div class="TeachersTeachingProgressStatistics_box">
                <div class="TeachersTeachingProgressStatistics_box_top">
                    <div class="TeachersTeachingProgressStatistics_box_top_div1">
                        教师姓名
                    </div>
                    <div class="TeachersTeachingProgressStatistics_box_top_div2">
                        学习进度
                    </div>
                    <div class="TeachersTeachingProgressStatistics_box_top_div3">
                        <div>
                            <div>
                                预学
                            </div>
                            答题时长
                        </div>
                        <div>
                            <div>
                                预学
                            </div>
                            完成情况
                        </div>
                    </div>
                    <div class="TeachersTeachingProgressStatistics_box_top_div4">
                        <div>
                            <div>
                                即学即练
                            </div>
                            学习知识点
                        </div>
                        <div>
                            <div>
                                即学即练
                            </div>
                            学习时长
                        </div>
                        <div>
                            <div>
                                即学即练
                            </div>
                            完成情况
                        </div>
                    </div>
                    <div class="TeachersTeachingProgressStatistics_box_top_div3">
                        <div>
                            <div>
                                阶梯化训练
                            </div>
                            闯关详情
                        </div>
                        <div>
                            <div>
                                阶梯化训练
                            </div>
                            闯关结果
                        </div>
                    </div>
                    <div class="TeachersTeachingProgressStatistics_box_top_div5">
                        <div>
                            <div>
                                基础小卷
                            </div>
                            完成份数
                        </div>
                        <div>
                            <div>
                                基础小卷
                            </div>
                            完成情况
                        </div>
                    </div>
                </div>
                <div class="TeachersTeachingProgressStatistics_box_center">
                    <vue-seamless-scroll v-if="dataInfo.length>=1" :data="dataInfo"  class="seamless-warp" :class-option="defaultOption">
                        <ul class="ul-scoll">
                            <li v-for="(item, index) in dataInfo" :key="index" class="TeachersTeachingProgressStatistics_item">
                                <div class="TeachersTeachingProgressStatistics_item_div1">
                                    <div class="TeachersTeachingProgressStatistics_item_div1_name">
                                        {{ item.uname }}
                                    </div>
                                    <div>
                                        ({{ item.bclassName }})
                                    </div>
                                </div>
                                <div class="TeachersTeachingProgressStatistics_item_div2">
                                    <span>{{ item.stuStudiedUnitCountAvg }}</span>/{{ item.teacherUnitSetCount }}
                                </div>
                                <div class="TeachersTeachingProgressStatistics_item_div3">
                                    <div>
                                        <span>{{ formateTime(item.yuxueAnswerSecAvg) }}</span>
                                    </div>
                                    <div>
                                        <span>{{ item.yuxueQuestionRightCountAvg }}</span>/{{ item.yuxueQuestionCountAvg }}
                                    </div>
                                </div>
                                <div class="TeachersTeachingProgressStatistics_item_div4">
                                    <div>
                                        <span>{{ item.jingjiangStudyPointCountAvg }}</span>/{{ item.jingjiangPointCountAvg }}
                                    </div>
                                    <div>
                                        <span>{{ formateTime(item.jingjiangStudyVideoSecAvg) }}</span>/{{ formateTime(item.jingjiangVideoSecAvg) }}
                                    </div>
                                    <div>
                                        <span>{{ item.jingjiangQuestionRightCountAvg }}</span>/{{ item.jingjiangQuestionCountAvg }}
                                    </div>
                                </div>
                                <div class="TeachersTeachingProgressStatistics_item_div3">
                                    <div>
                                        <span>{{ item.ladderTrainQuestionRightCountAvg }}</span>/{{ item.ladderTrainQuestionCountAvg }}
                                    </div>
                                    <div>
                                        <span>{{ item.passedCountAvg }}关</span>/{{ item.allPassCountAvg }}
                                    </div>
                                </div>
                                <div class="TeachersTeachingProgressStatistics_item_div3">
                                    <div>
                                        <span>{{ item.finishedXiaojuanCountAvg }}份</span>/{{ item.allXiaojuanCountAvg }}
                                    </div>
                                    <div>
                                        <span>{{ item.xiaojuanQuestionRightCountAvg }}</span>/{{ item.allXiaojuanQuestionCountAvg }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                    <div v-else class="TeachersTeachingProgressStatistics_box_center_tmpty">
                        正在生成~
                    </div>
                </div>
            </div>
        </div>
     </a-spin>
</template>

<script>
    import {
        bigScreenGradeTeacherStuLearns
    } from '@/api/other'
    import vueSeamlessScroll from 'vue-seamless-scroll'
    import TitlesImg from '@/components/CustomModule/TitlesImg.vue'
    export default {
        name: "TeachersTeachingProgressStatistics",
        props: {
            record: {
                type: Object
            },
            currentSubSchoolId: {
                type: String
            }
        },
        components: {
            vueSeamlessScroll,
            TitlesImg
        },
        // 监听属性 类似于data概念      
        computed: {
            defaultOption() {
                return {
                    step: this.record.step ? this.record.step : 1, // 数值越大速度滚动越快   
                    limitMoveNum: this.record.limitMoveNum ? this.record.limitMoveNum : 6, // 开始无缝滚动的数据量 this.dataList.length            
                    hoverStop: false, // 是否开启鼠标悬停stop          
                    direction: 1, // 0向下 1向上 2向左 3向右      
                    openWatch: true, // 开启数据实时监控刷新dom                
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1             
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3      
                    waitTime: 1000 // 单步运动停止的时间(默认值1000ms) 
                }
            }
        },
        data() {
            return {
                spinning: false,
                dataInfo: []
            };
        },
        methods: {
            formateTime(time) {
                const h = parseInt(time / 3600)
                const minute = parseInt(time / 60 % 60)
                const second = Math.ceil(time % 60)
                const hours = h
                const formatSecond = second > 59 ? 59 : second
                return `${hours > 0 ? `${hours}h` : ''}${minute > 0 ? `${minute}min` : ''}${formatSecond >= 0 && hours <= 0 ? `${formatSecond}s` : ''}`
            },
            loadData() {
                const that = this
                this.spinning = true
                bigScreenGradeTeacherStuLearns(
                {
                    subSchoolId: this.currentSubSchoolId,
                    useFakeData: this.record.useFakeData
                },
                (resp) => {
                    const resData = resp.data
                    if (resData == null) {
                        setTimeout(() => {
                            that.loadData()
                        }, 20000);
                    } else {
                        this.dataInfo = resData
                    }
                    this.spinning = false
                },
                (err) => {
                    console.log('err', err)
                    this.$message.error(err)
                    this.spinning = false
                }
                )
            },
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>
    .TeachersTeachingProgressStatistics {
        width: 100%;
        height: 100%;
        font-weight: normal;
    }
    .TeachersTeachingProgressStatistics_Title {
        position: relative;
        height: 15%;
    }
    .TeachersTeachingProgressStatistics_Span {
        display: flex;
        align-items: center;
        position: absolute;
        color: #fefdf9;
        font-size: 1em;
        top: 0;
        bottom: 0;
        left: 5%;
        margin: auto;
        margin-left: 5%;
    }
    .TeachersTeachingProgressStatistics_box {
        width: 100%;
        height: 85%;
    }
    .TeachersTeachingProgressStatistics_box_top {
        width: 100%;
        height: 4em;
        display: flex;
        align-items: center;
        color: #fefdf9;
    }
    .TeachersTeachingProgressStatistics_box_top>div {
        display: flex;
        align-items: center;
    }
    .TeachersTeachingProgressStatistics_box_top_div1 {
        width: 9%;
        height: 100%;
        background-color: #3046b3;
        border: 1px solid #2d79d7;
        border-right: none;
        justify-content: center;
    }
    .TeachersTeachingProgressStatistics_box_top_div2 {
        width: 9%;
        height: 100%;
        background-color: #0544a1;
        border: 1px solid #6ed6ef;
        border-right: none;
        justify-content: center;
    }
    .TeachersTeachingProgressStatistics_box_top_div3 {
        width: 18%;
        height: 100%;
        background-color: #3046b3;
        border: 1px solid #4291e3;
        border-right: none;
    }
    .TeachersTeachingProgressStatistics_box_top_div3>div {
        text-align: center;
        width: 50%;
    }
    .TeachersTeachingProgressStatistics_box_top_div4 {
        flex: 1;
        height: 100%;
        background-color: #05459f;
        border: 1px solid #4790e7;
        border-right: none;
    }
    .TeachersTeachingProgressStatistics_box_top_div4>div {
        text-align: center;
        width: 33.33%;
    }
    .TeachersTeachingProgressStatistics_box_top_div5 {
        width: 18%;
        height: 100%;
        background-color: #052c87;
        border: 1px solid #4daef1;
    }
    .TeachersTeachingProgressStatistics_box_top_div5>div {
        text-align: center;
        width: 50%;
    }
    .TeachersTeachingProgressStatistics_box_center {
        width: 100%;
        height: calc(100% - 4em);
    }
    .TeachersTeachingProgressStatistics_box_center_tmpty {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: #fefdf9;
    }
    .TeachersTeachingProgressStatistics_item {
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 0.5em;
        border: 1px solid #2d8ed5;
        border-radius: 0.2em;
        color: #adbed8;
        word-wrap: break-word;
    }
    .TeachersTeachingProgressStatistics_item span {
        color: #49ecff;
        font-size: 1.2em;
    }
    .TeachersTeachingProgressStatistics_item_div1 {
        width: 9%;
        height: 100%;
        border-right: 1px solid #2d8ed5;
        color: #4bd5fd;
        background: linear-gradient(to top right, #145bc8, rgba(0, 0, 0, 0));
        padding: 0.3rem 0.6em;
        text-align: center;
    }
    .TeachersTeachingProgressStatistics_item_div1_name {
        color: #fefdf9;
    }
    .TeachersTeachingProgressStatistics_item_div2 {
        width: 9%;
        text-align: center;
        padding: 0 0.6em;
    }
    .TeachersTeachingProgressStatistics_item_div3 {
        display: flex;
        align-items: center;
        width: 18%;
    }
    .TeachersTeachingProgressStatistics_item_div3 > div {
        width: 50%;
        height: 100%;
        padding: 0 0.6em;
        font-size: 0.8em;
    }
    .TeachersTeachingProgressStatistics_item_div4 {
        display: flex;
        align-items: center;
        flex: 1;
    }
    .TeachersTeachingProgressStatistics_item_div4 > div {
        width: 33.33%;
        height: 100%;
        padding: 0 0.6em;
        font-size: 0.8em;
    }
</style>